import React, {
	Component
} from 'react';
import './SimPlanPromo.css';
import Global from '../../Global';
import SimPlanPromoSmallBox from './SimPlanPromoSmallBox';
import SimPlanFilter from "./SimPlanFilter";

class SimPlanPromo extends Component {
    constructor(props) {
		super(props);
		
		this.state = {
			simPlanData: [],
			isInitialState: true
		}
	}
    
    getSimPlan(){
		//var simPlan;
		/*
		if(this.state.simPlanData.length > 0){
			simPlan = this.state.simPlanData;
		}else{
			simPlan = this.props.simPlanData;
		}
		*/
		let simPlan = this.state.isInitialState === true ? this.props.simPlanData : this.state.simPlanData;

        let lang = window.THREE_REACT_APP_GLOBAL.language;
        var html = simPlan.map((item, index) => {
            if (item.boxType === 'large') {
                let genStyle = {backgroundImage: "url('" + item.generationBackground + "')"};
                return <div className="big-promo-box" key={index}>
                    <div className="row hidden-xs">
                        <div className="col-xs-6 box-div" style={{backgroundImage: "url(" + item.boxImage + ")"}}>
                            {/*<img src={item.boxImage} border='0'/>*/}
                            <div style={genStyle}
                                 className={"generationLabel " + (item.generationLabel === '4.5G' ? 'lbl-45g' : 'lbl-4g')}>{item.generationLabel}</div>
                            <div className="boxTitle">{item.boxTitle}</div>
                        </div>
                        <div className="col-xs-6 box-div">
                            <div className="big-promo-box-content">
                                <div className="boxDesc">{item.boxDesc}</div>
                                <div className="boxMonthDesc"> {item.boxMonthDesc} </div>
                                <div className={"boxPrice" + (lang === "en" ? " boxPriceEN" : "")}> ${item.boxPrice} </div>
                                <div className="boxMonthDesc2"> {item.boxMonthDesc2} </div>
                                <div className="boxMonthDesc3">{item.boxMonthDesc3}</div>
                                <div className="plan-desc-content">
                                    <div style={{textAlign: "center"}} className="boxDataDesc">{item.boxDataDesc}</div>
                                    {this.getDataPlan(item.boxDataPlanLabel)}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row visible-xs">
                        <div className="col-xs-6 box-div" style={{backgroundImage: "url(" + item.boxImageMob + ")"}}>
                            {/*<img src={item.boxImage} border='0'/>*/}
                            <div style={genStyle}
                                 className={"generationLabel " + (item.generationLabel === '4.5G' ? 'lbl-45g' : 'lbl-4g')}>{item.generationLabel}</div>
                            <div className="boxTitle">{item.boxTitle}</div>
                        </div>
                        <div className="col-xs-6 box-div">
                            <div className="big-promo-box-content">
                                <div className="boxDesc">{item.boxDesc}</div>
                                <div className="boxMonthDesc"> {item.boxMonthDesc} </div>
                                <div className="boxPrice"> ${item.boxPrice} </div>
                                <div className="boxMonthDesc2"> {item.boxMonthDesc2} </div>
                                <div className="boxMonthDesc3">{item.boxMonthDesc3}</div>
                                <div className="plan-desc-content">
                                    <div style={{textAlign: "center"}} className="boxDataDesc">{item.boxDataDesc}</div>
                                    {this.getDataPlan(item.boxDataPlanLabel)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        });
        return html;
    }

    getDataPlan(boxDataPlanLabel){
        // var html = boxDataPlanLabel.map((item,index) =>(
        //     <div className="dataPlan" key={index}><a onClick={()=>this.props.onSelect(item.planType, item.planId)}>{item.dataLabel}</a></div>
        // ));
        let lang = window.THREE_REACT_APP_GLOBAL.language;
        let html = boxDataPlanLabel.map((item,index) =>(
            <div className={"dataPlan" + (lang === "en" ? " dataPlanEN" : "")}  key={index}>
                <a href={encodeURI(item.dataUrl)}>{item.dataLabel}</a>
            </div>
        ));

        return html;
    }

    getSmallBox(){
		// var simPlan;
		// if(this.state.simPlanData.length > 0){
		// 	simPlan = this.state.simPlanData;
		// }else{
		// 	simPlan = this.props.simPlanData;
		// }
		let simPlan = this.state.isInitialState === true ? this.props.simPlanData : this.state.simPlanData;

        var html = simPlan.map((item, index) => {
            if(item.boxType === 'medium')
                return <div className="col-xs-12 col-md-4 small-box-div" key={index}>
                    <SimPlanPromoSmallBox 
                        simPlanData = {item}
                        onSelect={(type, id) => this.props.onSelect(type, id)}
                    />
                </div>
        });

        return html;
    }


	filterPlans(selectData){
		//console.info(this.props.simPlanData);
		if(selectData.type.toLowerCase() === 'all'){
			this.setState({
			    simPlanData: this.props.simPlanData,
				isInitialState: false
			})
		}
		else{
			let plans = new Array();
			/* Round 1 Filter */
			plans = this.props.simPlanData.filter(item => item.simPlanType !== "");
			//console.log(plans);
			/* Round 2 Filter */
			plans = plans.filter(item => {
				let planTypes = item.simPlanType.toLowerCase().split("||");
				//return planTypes.indexOf(selectData.type) > -1;
				console.log(selectData.type.toLowerCase() + ", planTypes=" + planTypes[0]);
				return planTypes.includes(selectData.type.toLowerCase());
			});
			//console.log(plans);
			this.setState({
			    simPlanData: plans,
				isInitialState: false
			})
		}
	}
	
    render(){
        return (
		<React.Fragment>
			<SimPlanFilter handleFilter={this.filterPlans.bind(this)}/>
            <div id="sim-plan-promo-container">
                <div className="big-promo-box-container">
                    {this.getSimPlan()}
                </div>
                <div className="small-promo-box-container">
                    <div className="row">
                        {this.getSmallBox()}
                    </div>
                </div>
            </div>
		</React.Fragment>
        );
    }
}

export default SimPlanPromo;